import styled from '@emotion/styled';
import Checked from '@engineering/icons/checked';
import Info from '@engineering/icons/info';
import Tipp from '@engineering/icons/tipp';
import Warning from '@engineering/icons/warning';
import { MessageSeverity } from './Message.types';

const getColorBySeverity = (severity: MessageSeverity) => {
  switch (severity) {
    case MessageSeverity.SUCCESS:
      return 'green20';
    case MessageSeverity.ERROR:
      return 'red20';
    default:
      return 'blue20';
  }
};

const Wrapper = styled.div<{
  visible: boolean;
  severity: MessageSeverity;
}>`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  margin: ${({ theme }) => theme.spacing[40]} 0;
  padding: ${({ theme }) => theme.spacing[40]};
  border: ${({ theme }) => `1px solid ${theme.colors.neutral.grey40}`};
  border-radius: ${({ theme }) => theme.radius.md};
  gap: ${({ theme }) => theme.spacing[40]};
  color: ${({ theme }) => theme.colors.neutral.grey160};
  background: ${({ theme, severity }) =>
    theme.colors.accent[getColorBySeverity(severity)]};
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: 1rem;
  line-height: 1.5;
  text-align: start;
`;

const Content = styled.div`
  flex-grow: 1;
`;

const Headline = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[20]};
  font-family: ${({ theme }) => theme.fontFamily.alternate};
`;

const Icon = styled.div`
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
`;

const InfoIcon = styled(Icon)`
  fill: ${({ theme }) => theme.colors.accent.blue100};
`.withComponent(Info);

const TipIcon = styled(Icon)`
  fill: ${({ theme }) => theme.colors.accent.blue100};
`.withComponent(Tipp);

const ErrorIcon = styled(Icon)`
  fill: ${({ theme }) => theme.colors.accent.red100};
`.withComponent(Warning);

const SuccessIcon = styled(Icon)`
  fill: ${({ theme }) => theme.colors.accent.green100};
`.withComponent(Checked);

export {
  Wrapper,
  Headline,
  Content,
  InfoIcon,
  TipIcon,
  ErrorIcon,
  SuccessIcon,
};
